<template>
  <div id="poll-question">

    <div class="form-group">
      <label class="label">{{'Question ' + (index + 1)}}</label>
      <input type="text" class="input" v-model="question.question"
        placeholder="Add a question here"
      >
    </div>

    <label class="label">Answers</label>
    <draggable v-model="question.answers">
      <transition-group>
        <div v-for="(answer, id) in question.answers" :key="id">
          <div class="answer">
            <input :tabindex="id" v-model="question.answers[id].answer" class="input" type="text"
              :placeholder="'Add answer ' + (id+1)"
            >
            <button class="button is-light is-left">
              <span class="icon">
                <i class="fas fa-arrows-alt"></i>
              </span>
            </button>
            <button class="button is-danger is-right" @click="deleteAnswer(id)">
              <span class="icon">
                <i class="fas fa-trash-alt"></i>
              </span>
            </button>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="field is-grouped">
      <p class="control">
        <button class="button is-info" @click="newAnswer">
          <span class="icon">
            <i class="fas fa-plus"></i>
          </span>
          <span>New Answer</span>
        </button>
      </p>
      <p class="control">
        <button class="button is-danger" @click="$emit('delete-question')">
          <span class="icon">
            <i class="fas fa-trash"></i>
          </span>
          <span>Remove Answer</span>
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  props: ['question', 'index'],
  data() {
    return {
    };
  },
  components: { draggable },
  methods: {
    newAnswer() {
      // Add a blank answer to the array
      this.question.answers.push({ id: '', answer: '' });
      this.$nextTick(() => {
        const answers = this.$el.getElementsByClassName('answer');
        answers[answers.length - 1].querySelector('input').focus();
      });
    },
    deleteAnswer(index) {
      if (index > -1) {
        this.question.answers.splice(index, 1);
      }
    },
    newAnswerEnter(id) {
      if (this.question.answers.length === id + 1) {
        this.newAnswer();
      }
    },
  },
};
</script>

<style>
#poll-question {
  padding: 30px;
  border: 1px solid #f1f1f1;
  margin-bottom: 20px;
  position: relative;
}

.button.is-left {
  position: absolute;
  left: 1px;
  top: 1px;
  bottom: 1px;
  height: auto;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.button.is-right {
  position: absolute;
  right: 1px;
  top: 1px;
  bottom: 1px;
  height: auto;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* .delete-question {
  position: absolute;
  right: 5px;
  bottom: 5px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 3px;
  color: #e74c3c;
  cursor: pointer;
  font-size: 10px;
} */

.answer {
  position: relative;
  margin-bottom: 10px;
}
.answer i {
  position: absolute;
  top: 1px;
  height: 32px;
  background: #f9f9f9;
  width: 32px;
  text-align: center;
  line-height: 37px;
  border: 0px;
  border-right: 0px;
  cursor: move;
}
.answer svg {
  left: 1px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.answer i.voyager-trash {
  right: 1px;
  background: #e74c3c;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  color: #fff;
  cursor: pointer;
}
.answer input {
  padding-left: 50px;
}
.btn-new i {
  position: relative;
  top: 2px;
}
</style>
